import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import { BLOCK_MODULE_NAMESPACE, BLOCK_GET_BLOCK, BLOCK_GET_BLOCKS } from '../../../../store/block';
import { IBlockListingViewModel, BlockDto, IBlockParameter } from '../../../../models/block';
import { eventBus } from '../../../../main';

const BlockStore = namespace(BLOCK_MODULE_NAMESPACE)

@Component({
  components: {
    'sidebar-widget-ticket': async () => import('../block-sidebar-widget-ticket/BlockSidebarWidgetTicket.vue'),
    'sidebar-widget-tenants': async () => import('../block-sidebar-widget-tenants/BlockSidebarWidgetTenants.vue'),
    'sidebar-widget-owners': async () => import('../block-sidebar-widget-owners/BlockSidebarWidgetOwners.vue'),
    'sidebar-widget-apartments': async () => import('../block-sidebar-widget-apartments/BlockSidebarWidgetApartments.vue'),
    'sidebar-widget-documents': async () => import('../block-sidebar-widget-documents/BlockSidebarWidgetDocuments.vue'),
    'sub-navigation-title': async () => import('@/components/sub-navigation-title/SubNavigationTitle.vue')
  }
})
class BlockApartmentSidebar extends Vue {
  _cleatTimeout: any;
  dtMenu: boolean;
  dtSearch: string;
  dtExpandActive: number;
  dtWidget: {
    key: string,
    otherKeys?: string[],
    totalKey: string,
    name: string,
    icon?: string,
    callbackFunction: Function,
  }[];


  /**
   * Store declarations
   */
  @BlockStore.Getter currentBlock: IBlockListingViewModel | BlockDto;
  @BlockStore.Getter blocks: IBlockListingViewModel[];
  @BlockStore.Getter blockParameter: IBlockParameter;
  @BlockStore.Getter canManageDocuments: boolean


  @BlockStore.Action(BLOCK_GET_BLOCK)
  storeGetBlockById: (blockId: string) => Promise<any>
  @BlockStore.Action(BLOCK_GET_BLOCKS)
  storeGetBlocks: (payload: { merge: boolean, param: IBlockParameter }) => Promise<any>
  constructor() {
    super();
    this.dtSearch = null;
    this.dtMenu = false;
    this.dtWidget = [
      {
        key: 'infos',
        name: 'Informations générales',
        totalKey: '',
        callbackFunction: this.handleExpand
      },
      {
        key: 'ticket',
        icon: 'keyboard_arrow_down',
        name: 'Demandes en cours',
        totalKey: 'totalOpenedTicket',
        callbackFunction: this.handleExpand
      },
      {
        key: 'contact',
        otherKeys: ['tenant','owner'],
        icon: 'keyboard_arrow_down',
        name: 'Contacts',
        totalKey: 'totalContact',
        callbackFunction: this.handleExpand
      },
      /*{
        key: 'tenant',
        icon: 'keyboard_arrow_down',
        name: 'Locataires',
        totalKey: 'totalTenant',
        callbackFunction: this.handleExpand
      },
      {
        key: 'owner',
        icon: 'keyboard_arrow_down',
        name: 'Propriétaires',
        totalKey: 'totalOwner',
        callbackFunction: this.handleExpand
      },*/
      {
        key: 'apartment',
        name: 'Lots',
        totalKey: 'totalApartment',
        callbackFunction: this.handleExpand
      },
      /*{
        key: 'equipment',
        name: `Equipements de l'immeuble`,
        totalKey: null,
        callbackFunction: this.handleExpand
      },*/
      /** Deactive for task DRIV-1188 */
      {
        key: 'document',
        icon: 'add',
        name: 'Documents associés',
        totalKey: 'totalDocument',
        callbackFunction: this.handleExpand
      }
    ]
    this.dtExpandActive = 0

  }

  get lblSetting(): { [prop: string]: string } {
    return {
      ...require('@/locales/block').default
    }
  }

  handleChange(target: any) {
    console.log(target.data, this.dtSearch, 'target')
  }
  handleExpand(key: string) {
    this.$router.push({ path: key })
  }
  getActiveClass(key: string) {
    return (this.$route.path.indexOf(key) > -1
      && this.$route.params.cid === undefined) ? 'subnav__item--active' : null;
  }
  getTotal (key: string) {
    if (!this.currentBlock) return null
    let total: number = this.currentBlock[key]
    return total > 0 ? `(${total})` : null
  }
  getPath(key:string){
    if(key === 'infos') return `/block/${this.$route.params.id}`
    return `/block/${this.$route.params.id}/${key}`
  }
  getTotalNumber(key: string) {
    if (this.currentBlock) {
      return this.currentBlock[key];
    }
    return null;
  }
  get blockId(): string {
    return this.$route.params.id
  }
  get coCurrentBlockName(): string {
    if (this.currentBlock)
      return this.currentBlock.name
    return null;
  }
  get coBlocks () { return this.blocks }

  get displayEquipments () {
    let userModules = JSON.parse(localStorage.getItem('modules'))
    return userModules.block_equipment || false
  }

  get displayMaintenances () {
    if (!localStorage.getItem('block_maintenance')) return false
    return JSON.parse(localStorage.getItem('block_maintenance')).view_maintenance || false
  }

  get displayVehicleFleet () {
    if (!localStorage.getItem('block_vehicle_fleet')) return false
    return JSON.parse(localStorage.getItem('block_vehicle_fleet')).view_parc || false
  }

  getVisibility(key: string, target: string) {
    return key === target
  }

  created () {
    if (!this.canManageDocuments) this.dtWidget.pop()
    if (this.displayEquipments) {
      this.dtWidget.push({
        key: 'equipment',
        icon: 'add',
        name: 'Équipements',
        totalKey: 'totalEquipment',
        callbackFunction: this.handleExpand
      })
    }
    // ==== VehicleFleet
    if (this.displayVehicleFleet) {
      this.dtWidget.push({
        key: 'vehicleFleet',
        icon: 'add',
        name: 'Parc Véhicule',
        totalKey: 'totalVehicleFleet',
        callbackFunction: this.handleExpand
      })
    }
    // ===== maintenance listing page
    if(this.displayMaintenances) {
      this.dtWidget.push({
        key: 'maintenance',
        icon: 'add',
        name: 'Maintenance',
        totalKey: 'totalMaintenance',
        callbackFunction: this.handleExpand
      })
    }
    this.handleActiveWidget()
    // this.$watch('$route', () => this.handleActiveWidget())
  }

  updated () {
    this.handleActiveWidget()
  }

  mounted () {

    eventBus.$on('RELOAD_BLOCK_DASHBORD',(blockId)=>{
      console.log('EVENT ===================> RELOAD_BLOCK_DASHBORD')
      this.storeGetBlockById(this.$route.params.id);
    })

    this.$watch('$route.params', (nVal, oVal) => this.handleGetBlockDashboardById(nVal, oVal))
    this.storeGetBlockById(this.$route.params.id);
    if (this.blocks.length === 0)
      this.storeGetBlocks({ merge: false, param: this.blockParameter });
  }

  beforeDestroy()
  {
    eventBus.$off('RELOAD_BLOCK_DASHBORD')
  }

  handleActiveWidget(){
    this.dtWidget.forEach((widget,index)=>{
      if(this.$route.name === 'block_detail') this.dtExpandActive= 0

      if(this.$route.path.indexOf(widget.key) !== -1) this.dtExpandActive= index
      if(widget.otherKeys)
          widget.otherKeys.forEach(key => {
            if(this.$route.path.indexOf(key) !== -1) this.dtExpandActive= index
          })

    })
  }

  handleGetBlockDashboardById (nVal: { id: string }, oVal: { id: string }) {
    if (nVal.id !== oVal.id) {
      clearTimeout(this._cleatTimeout)
      this._cleatTimeout = setTimeout(() => {
        this.storeGetBlockById(nVal.id);
      }, 300);
    }
  }
  handleClick(event: { data: any, index: number }) {
    clearTimeout(this._cleatTimeout)
    this._cleatTimeout = setTimeout(() => {
      this.dtMenu = false;
      this.$router.push({
        path: `/block/${event.data.id}`,
        params: {
          id: event.data.id
        }
      })
    }, 300);
  }
}

export default BlockApartmentSidebar;



// WEBPACK FOOTER //
// ./src/containers/block/components/block-apartment-sidebar/index.ts